import { render, staticRenderFns } from "./MDForm.vue?vue&type=template&id=4419d359&"
import script from "./MDForm.vue?vue&type=script&lang=js&"
export * from "./MDForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports